import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
/**
 * Tabs Component
 * Feature: 001-github-notifications
 * Tab-based navigation for Profile, Notifications, and Settings
 */
import React from 'react';
/**
 * Tabs component for navigation
 */
export function Tabs({ tabs, activeTab, onTabChange }) {
    return (_jsx("div", { className: "border-b border-gray-200 dark:border-gray-700", children: _jsx("nav", { className: "-mb-px flex space-x-8", "aria-label": "Tabs", children: tabs.map((tab) => (_jsx("button", { onClick: () => onTabChange(tab.id), className: `
              whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium
              ${activeTab === tab.id
                    ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'}
            `, "aria-current": activeTab === tab.id ? 'page' : undefined, children: _jsxs("span", { className: "flex items-center gap-2", children: [tab.icon, tab.label] }) }, tab.id))) }) }));
}
